import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import GreetingsHeader from '../components/GreetingsHeader';
import HeroCarousel from '../components/HeroCarousel';
import HeaderIcons from '../components/HeaderIcons';
import DrawerIcons from '../components/DrawerIcons';
import Toggler from '../components/Toggler';
import { postIpsSettings } from '../requests';

const toggleValues = ['Alphabetical', 'Collection'];

export default function MainContentView({
  name,
  appGroups: appGroupsIn = [],
  cmsBanners,
  toggledValue,
  affiliations
}) {
  const [selectedToggleValue, setSelectedToggleValue] = useState(
    toggledValue || toggleValues[1]
  );

  const [appGroups, setAppGroups] = useState(appGroupsIn);

  function parseAppGroups(appGroups) {
    if (appGroups.length > 0) {
      return [appGroups[0].apps, appGroups.slice(1)];
    }
    // should never hit this
    return [[], []];
  }
  const [iconHeaders, iconGroups] = parseAppGroups(appGroups);

  function toggleClosedGroup(id, opened) {
    setAppGroups((groups) =>
      groups.map((group) => {
        if (group.id === id) {
          group.opened = opened;
        }
        return group;
      })
    );
  }

  useEffect(() => {
    // @TODO MAKE IT SHOW IT DOES"T UPDATE ON LOAD
    updateSettings();
  }, [appGroups, selectedToggleValue]);

  async function updateSettings() {
    try {
      const groupStatus = appGroups
        .filter((g) => g.id !== '-1')
        .map((g) => ({ id: g.id, opened: g.opened }));
      await postIpsSettings({ viewType: selectedToggleValue, groupStatus });
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Container>
      <div className='width-container'>
        <GreetingsHeader name={name} />
        <div className='hero inner-width-container'>
          <HeroContainer>
            <HeroCarousel cmsBanners={cmsBanners} appGroups={appGroups} />
          </HeroContainer>
        </div>

        <HeaderIcons icons={iconHeaders} affiliations={affiliations}/>

        <Spacer height='24px' />
        <TogglerContainer>
          <Toggler
            values={toggleValues}
            selectedValue={selectedToggleValue}
            setSelectedValue={setSelectedToggleValue}
          />
        </TogglerContainer>

        {selectedToggleValue === toggleValues[1] ? (
          <DrawersContainer>
            {iconGroups.map((iconGroup, index) => (
              <DrawerIcons
                toggleOpened={() =>
                  toggleClosedGroup(iconGroup.id, !iconGroup.opened)
                }
                key={index}
                {...iconGroup}
                isLast={index === iconGroups.length - 1}
                affiliations={affiliations}
              />
            ))}
          </DrawersContainer>
        ) : (
          <DrawersContainer>
            <DrawerIcons
              name='Alphabetical'
              isClosable={false}
              isLast
              affiliations={affiliations}
              apps={iconGroups
                .reduce((addedLinks, iconGroup) => {
                  iconGroup.apps.forEach((link) => {
                    // see if it is already in icons
                    const foundLink = addedLinks.find(
                      (addedLink) => addedLink.label === link.label
                    );
                    if (!foundLink) {
                      // put in icons
                      addedLinks.push(link);
                    }
                  });

                  return addedLinks;
                }, [])
                .sort((linkA, linkB) => {
                  const a = linkA.label.toUpperCase();
                  const b = linkB.label.toUpperCase();
                  return a < b ? -1 : a > b ? 1 : 0;
                })}
            />
          </DrawersContainer>
        )}
        <Spacer height='95px' />
      </div>
    </Container>
  );
}

const HeroContainer = styled.div`
  margin-top: 24px;
  margin-left: auto;
  margin-right: auto;
  /* position: absolute; */
  top: 0;
  left: 0;
  width: 100%;
  /* height: 435px; */
`;

const Spacer = styled.div`
  height: ${({ height }) => height};
`;

const TogglerContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const DrawersContainer = styled.div``;
const Container = styled.div`
  .hero {
    /* padding-top: 31.7%; */
    position: relative;
  }
  @media (max-width: 830px) {
    .hero {
      width: 95%;
    }
  }
`;
